import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-SynchDialog" */'shared-components/components/SynchDialog'));
